import { Collapse } from 'bootstrap-5'

/**
 * Bootstrap 5 collapse toggle driven only by the app's bootstrap-5 copy.
 *
 * chameleon-vue bundles its own (beta) Bootstrap 5, whose data-api listens on the
 * document in the capture phase. With both copies handling data-bs-toggle="collapse",
 * one click expands the panel and the other immediately collapses it again. Toggles
 * using this directive must NOT have data-bs-toggle="collapse".
 *
 * Usage: <div v-collapse="'#targetId'">
 */
export default {
  bind(el, { value }) {
    const onClick = (event) => {
      event.preventDefault()
      const target = document.querySelector(value)
      if (target) {
        Collapse.getOrCreateInstance(target, { toggle: false }).toggle()
      }
    }

    el.addEventListener('click', onClick)
    el._vCollapse = { onClick, value }
  },

  unbind(el) {
    const handlers = el._vCollapse

    if (handlers) {
      el.removeEventListener('click', handlers.onClick)
      const target = document.querySelector(handlers.value)
      if (target) {
        const instance = Collapse.getInstance(target)
        if (instance) {
          instance.dispose()
        }
      }
      delete el._vCollapse
    }
  }
}
